(() => {
  const country = document.currentScript?.dataset.country;
  let observed = null;
  let frame = 0;
  const render = () => {
    frame = 0;
    const cart = document.getElementById('rebuy-cart');
    if (!cart) return;
    cart.querySelectorAll('.message').forEach((message) => {
      if (!/free shipping/i.test(message.textContent)) return;
      const text = country === 'US'
        ? message.textContent.replace(/free shipping/gi, 'Free US shipping')
        : 'Shipping rates shown at checkout.';
      if (message.textContent !== text) message.textContent = text;
    });
    cart.querySelectorAll('.rebuy-cart__progress-bar-wrapper').forEach((bar) => {
      if (country !== 'US') { bar.hidden = true; return; }
      bar.querySelectorAll('.rebuy-cart__progress-bar-prompt b').forEach((label) => {
        if (/free shipping/i.test(label.textContent)) label.textContent = label.textContent.replace(/free shipping/gi, 'FREE US SHIPPING');
      });
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(render); };
  const connect = () => {
    const cart = document.getElementById('rebuy-cart');
    if (cart && cart !== observed) {
      observed = cart;
      new MutationObserver(schedule).observe(cart, { childList: true, subtree: true });
    }
    schedule();
  };
  ['rebuy.ready', 'rebuy:smartcart.ready', 'rebuy:cart.change', 'rebuy:smartcart.show'].forEach((name) => document.addEventListener(name, connect));
  window.addEventListener('pageshow', connect);
  connect();
})();
